module.exports = __webpack_public_path__ + "static/20-03e95fb4393f578c002d4c1cd5f1385d.jpg";